// extracted by mini-css-extract-plugin
module.exports = {"row":"_3pNevoZc flex col-12 md-col-7 mx-auto clearfix","graphic":"DddW4nDb left","copy":"_2lhXsuiX left","icon":"_3OHZZ7c3","link":"_1_bSgIMy"};